export const suggestedItems = [
  {
    title: "Explore Latest Special Offers",
    type: "suggested",
    uri: "/special-offers",
    image: {
      variants: [
        {
          url: "/images/suggested-1.webp",
          alt: "Special Offers",
          style: "default",
          title: "Special Offers",
        },
      ],
    },
  },
  {
    title: "Trending Travel Inspiration",
    type: "suggested",
    uri: "/inspiration/trending",
    image: {
      variants: [
        {
          url: "/images/suggested-2.webp",
          alt: "Special Offers",
          style: "default",
          title: "Special Offers",
        },
      ],
    },
  },
  {
    title: "Tailor-Made Group Travel Made Easy",
    type: "suggested",
    uri: "/groups",
    image: {
      variants: [
        {
          url: "/images/suggested-3.webp",
          alt: "Special Offers",
          style: "default",
          title: "Special Offers",
        },
      ],
    },
  },
  {
    title: "Our Globetrotting Editor’s Travel Picks",
    type: "suggested",
    uri: "/inspiration/editors-picks",
    image: {
      variants: [
        {
          url: "/images/suggested-4.webp",
          alt: "Special Offers",
          style: "default",
          title: "Special Offers",
        },
      ],
    },
  },
  {
    title: "Discover All Destinations",
    type: "suggested",
    uri: "/destinations",
    image: {
      variants: [
        {
          url: "/images/suggested-5.webp",
          alt: "Special Offers",
          style: "default",
          title: "Special Offers",
        },
      ],
    },
  },
]
